/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Online_RecheckinInputs */



/**
* | output |
* | --- |
* | "You've been checked out. Join the server to check in again." |
*
* @param {Tournament_Online_RecheckinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_online_recheckin = /** @type {((inputs?: Tournament_Online_RecheckinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Online_RecheckinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez été dépointé. Rejoignez le serveur pour pointer à nouveau.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su check-in ha sido cancelado. Únase al servidor para volver a hacer check-in.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu check-in foi cancelado. Entre no servidor para fazer check-in novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il suo check in è stato annullato. Acceda al server per fare check in di nuovo.")
	return /** @type {LocalizedString} */ ("You've been checked out. Join the server to check in again.")
});